import { Radio } from '../Radio';
import { RadioButtonElement, RadioLabelElement } from './style';

export interface RadioElementProps {
    label?: React.ReactNode | string;
    checked?: boolean;
    value?: string;
    name?: string;
    className?: string;
    disabled?: boolean;
    inputHidden?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
    id?: string;
    small?: boolean;
}

const RadioButton: React.FC<RadioElementProps> = ({
    label,
    checked,
    value,
    name,
    className,
    disabled,
    inputHidden,
    onChange,
    id,
    small,
    ...other
}: RadioElementProps) => (
    <RadioButtonElement checked={checked} disabled={disabled} {...other}>
        <Radio checked={checked} disabled={disabled} onChange={onChange} inputHidden={inputHidden} value={value} />
        {label && (
            <RadioLabelElement disabled={disabled} htmlFor={name} checked={checked} small={small}>
                {label}
            </RadioLabelElement>
        )}
    </RadioButtonElement>
);
export default RadioButton;
